import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const BLUE = '#2B7FFF';
const BG = '#050810';
const SURFACE = '#0B1120';
const BORDER = 'rgba(255,255,255,0.07)';
const OFF_WHITE = '#A0AABB';

const values = [
  {
    icon: '✂️',
    title: 'Built by someone doing the work',
    body: 'Mane wasn\'t built in a boardroom. It was built by a working barber who got tired of paying $30/month to Booksy for a tool that never really fit.',
  },
  {
    icon: '💸',
    title: 'No fees on your income',
    body: 'Flat subscription. We never take a cut of your bookings, tips, or revenue. What you earn is yours.',
  },
  {
    icon: '🤝',
    title: 'Founding members come first',
    body: 'The first 50 professionals who trust us with their business get free access for life. That\'s our commitment — not a marketing gimmick.',
  },
];

const contact = [
  { label: 'Email', value: 'christiangflairbiz@gmail.com', href: 'mailto:christiangflairbiz@gmail.com' },
  { label: 'Phone', value: '(561) 888-5567', href: 'tel:+15618885567' },
  { label: 'Location', value: 'Royal Palm Beach, FL', href: null },
  { label: 'Business', value: 'Christian G Flair LLC', href: null },
];

export default function About() {
  return (
    <div style={{ background: 'transparent', color: '#fff', minHeight: '100vh', fontFamily: 'Inter, -apple-system, sans-serif' }}>
      <Helmet>
        <title>About — Mane</title>
        <meta name="description" content="Mane was built by Christian G Flair, a barber in Royal Palm Beach, FL who got tired of losing money to booking platforms. Zero fees. Zero commission." />
        <meta property="og:title" content="About Mane — Built by a Barber, for Barbers" />
        <meta property="og:description" content="The story of why a barber built a platform that charges 0% commission." />
        <meta property="og:locale" content="en_US" />
        <meta property="og:image" content="https://joinmane.com/og-image-v8.png" />
      </Helmet>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '72px 24px 96px' }}>

        {/* Header */}
        <div style={{ marginBottom: '56px' }}>
          <Link to="/" style={{ color: BLUE, fontSize: '11px', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', textDecoration: 'none' }}>
            MANE
          </Link>
          <h1 style={{ fontSize: 'clamp(36px, 6vw, 52px)', fontWeight: 900, letterSpacing: '-0.03em', margin: '20px 0 0', lineHeight: 1.05 }}>
            About Mane
          </h1>
        </div>

        {/* Story */}
        <div style={{ marginBottom: '64px', paddingBottom: '64px', borderBottom: `1px solid ${BORDER}` }}>
          <p style={{ fontSize: '18px', lineHeight: 1.8, color: '#ddd', marginBottom: '20px' }}>
            Mane started in a barber suite in Royal Palm Beach, FL. Not with venture capital — with a chair, a clientele, and a frustration.
          </p>
          <p style={{ fontSize: '16px', lineHeight: 1.8, color: OFF_WHITE, marginBottom: '20px' }}>
            Booking apps cost $30–$50/month and take a percentage of every transaction. They're designed for big salons, not independent professionals who are already covering rent, supplies, and everything else on their own.
          </p>
          <p style={{ fontSize: '16px', lineHeight: 1.8, color: OFF_WHITE, marginBottom: '20px' }}>
            So we built something different. A booking and client management platform for one-person businesses and small shops — flat price, no percentages, no bloat.
          </p>
          <p style={{ fontSize: '16px', lineHeight: 1.8, color: OFF_WHITE }}>
            The goal isn't to be the biggest platform. It's to be the one that actually works for the people doing the work.
          </p>
        </div>

        {/* Values */}
        <div style={{ marginBottom: '64px', paddingBottom: '64px', borderBottom: `1px solid ${BORDER}` }}>
          <h2 style={{ fontSize: '20px', fontWeight: 800, marginBottom: '32px', letterSpacing: '-0.01em' }}>What we stand for</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
            {values.map((v) => (
              <div key={v.title} style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                <div style={{
                  width: '44px',
                  height: '44px',
                  background: SURFACE,
                  border: `1px solid ${BORDER}`,
                  borderRadius: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '20px',
                  flexShrink: 0,
                }}>
                  {v.icon}
                </div>
                <div>
                  <p style={{ fontWeight: 700, fontSize: '15px', marginBottom: '6px' }}>{v.title}</p>
                  <p style={{ color: OFF_WHITE, fontSize: '14px', lineHeight: 1.7 }}>{v.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div style={{ marginBottom: '56px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 800, marginBottom: '28px', letterSpacing: '-0.01em' }}>Get in touch</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {contact.map((c) => (
              <div key={c.label} style={{ display: 'flex', gap: '16px', alignItems: 'center', paddingBottom: '16px', borderBottom: `1px solid ${BORDER}` }}>
                <span style={{ color: OFF_WHITE, fontSize: '13px', width: '80px', flexShrink: 0 }}>{c.label}</span>
                {c.href ? (
                  <a href={c.href} style={{ color: '#fff', fontSize: '14px', fontWeight: 600, textDecoration: 'none' }}>{c.value}</a>
                ) : (
                  <span style={{ color: '#fff', fontSize: '14px', fontWeight: 600 }}>{c.value}</span>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Footer nav */}
        <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
          <Link to="/" style={{ color: OFF_WHITE, fontSize: '13px', textDecoration: 'none' }}>← Back to home</Link>
          <Link to="/founding" style={{ color: BLUE, fontSize: '13px', fontWeight: 600, textDecoration: 'none' }}>Claim founding spot →</Link>
          <Link to="/pricing" style={{ color: OFF_WHITE, fontSize: '13px', textDecoration: 'none' }}>Pricing</Link>
          <Link to="/privacy" style={{ color: OFF_WHITE, fontSize: '13px', textDecoration: 'none' }}>Privacy</Link>
          <Link to="/terms" style={{ color: OFF_WHITE, fontSize: '13px', textDecoration: 'none' }}>Terms</Link>
        </div>

      </div>
    </div>
  );
}
